import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-error',
  templateUrl: './error.page.html',
  styleUrls: ['./error.page.scss'],
})
export class ErrorPage implements OnInit {
  @Input() mainErrorMessage: string;
  @Input() buttonText?: string;
  @Input() showButton: boolean;

  constructor() {}

  ngOnInit() {
    this.mainErrorMessage = 'There was an error that occurred...';
    this.buttonText = 'Test';
    this.showButton = false;
  }
}
